import { render, staticRenderFns } from "./AddEvent.vue?vue&type=template&id=413c1565"
import script from "./AddEvent.vue?vue&type=script&lang=ts"
export * from "./AddEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports